import { render } from "./AppTitle.vue?vue&type=template&id=5848e30d"
const script = {}
script.render = render

export default script